import React										from 'react';
import moment										from 'moment';

import Icon											from '../Icon';
import Checkbox										from '../Checkbox';
import DevicesBadges								from '../Badge/DevicesBadges';

import {useAppSelector}								from '../../../app/hooks';
import {InputValues}								from '../Input/interface';
import {Order, OrderAddressList}					from '../../../redux/order/interface';

import {ft_replaceSpecialChar}						from '../../functions/search';
import ft_cssVar									from '../../functions/getCssVar';
import {ft_formatPrice}								from '../../functions/format';

import img_truck									from '../../images/icon/truck.svg';

import LANGUAGE										from '../../language';

import '../User/UserComponent.css';

interface DeviceCardProps {
	order: Order,
	addressOrder: OrderAddressList,
	indexAddressOrder: number,
	selected?: boolean,
	search?: InputValues,
	onClick?: () => void,
	checkbox?: boolean | 'round',
	previousSelected?: boolean,
	style?: React.CSSProperties
}

function DeviceCard(props: DeviceCardProps): React.ReactElement {
	const lang = useAppSelector(state => state.settings.lang);

	const TEXTE = LANGUAGE(lang);

	if (props.search && !ft_replaceSpecialChar(props.order.number, true, true).includes(ft_replaceSpecialChar(props.search, true, true)))
		return <div />;

	let status = 'stock';

	if (props.addressOrder.status.name === 'refusedByFunder' || props.addressOrder.status.name === 'refusedByValala')
		status = 'replacement';
	if (props.addressOrder.status.name.startsWith('inPreparation') || props.addressOrder.status.name === 'shipped' || props.addressOrder.status.name === 'delivered')
		status = '';

	return (
		<div
			onClick={props.onClick ? props.onClick : undefined}
			className={`userCard ${props.selected && 'selected'}`}
			style={{
				marginTop:  (props.previousSelected && props.selected) ? -2 : undefined,
				paddingTop: (props.previousSelected && props.selected) ? 16 : undefined,
				...props.style
			}}
		>
			{props.checkbox &&
				<Checkbox
					active={props.selected}
					style={{marginRight: 5}}
					round={props.checkbox === 'round'}
				/>
			}
			<div className={'userCardImg'}>
				<Icon
					iconBorder
					size={40}
					borderSize={0}
					icon={img_truck}
					iconColor={ft_cssVar('primary-600')}
				/>
			</div>
			<div className={'contactListItemInfos'}>
				<span className={`deviceStatus ${status}`}>{TEXTE.order.status[props.addressOrder.status.name]}</span>
				<div className={'contractListNumberContainer'}>
					<span className={'weight-500 gray-900'}>{`${TEXTE.order.order} ${props.order.number}${props.order.addressList.length > 1 ? `-${props.indexAddressOrder + 1}` : ''}`}</span>
					<span className={'weight-500 primary-600'}>{ft_formatPrice(props.order.price)}</span>
				</div>
				<span className={'text-xs gray-600'}>{`${TEXTE.order.the} ${moment(props.order.data.creationDate).format('DD/MM/YYYY')}`}</span>
				<DevicesBadges addressOrder={props.addressOrder} />
			</div>
		</div>
	);
}

export default DeviceCard;
